
import Banner from "@/components/Banner.vue";
import { questionsList } from "@/static/askedQuestions";
export default {
  head(){
    return {
      title: 'Gavekort',
      titleTemplate: `%s |  ${this.$store.getters["cmsConfigHomepage/getChainName"]}`,
    }
  },
  layout: "HomepageLayout",
  components: { Banner },
  name: "Giftcard",
  // asyncData(context) {
  //   var modules = this.$store.getters['cmsConfigHomepage/getModules']
  //   if(!this.$store.getters['cmsConfigHomepage/getGiftcardConfigActiveStatus']){
  //     this.$router.replace({ path:`/`})
  //   }
  // },
  data: () => ({
    isMounted: false,
    isLandingPage: false,
    bannerImgRegular:"https://res.cloudinary.com/odin-systemer/image/upload/w_1170,h_300,g_face,g_face,c_fill,g_center,e_sharpen:100/v1523948343/resources/Hjemmeside_Malbilder/giftcard_banner.jpg",
    bannerImgMobile: "https://res.cloudinary.com/odin-systemer/image/upload/w_500,h_250,g_face,g_face,c_fill,g_center,e_sharpen:100/v1523948343/resources/Hjemmeside_Malbilder/giftcard_banner.jpg"
  }),
  beforeMount(){
     if (!this.giftcardStatus) this.$router.push('/')
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    giftcardStatus() {
      return this.$store.getters["cmsConfigHomepage/getGiftcardActiveStatus"];
    },
    askedQuestions() {
      return questionsList();
    },
    chainId() {
      return this.$store.getters['cmsConfigHomepage/getChainId']
    },
    isDraft() {
      return this.$store.getters['cmsConfigHomepage/isDraftMode']
    }
  },
};
